var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":"没有更多了"}},_vm._l((_vm.searchTipsList),function(item,index){return _c('van-cell',{key:index,attrs:{"title":item}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }